import ScrollReveal from "scrollreveal";

export function scrollR() {
  var sr = ScrollReveal();

  sr.reveal(".revealthis", {
    origin: "bottom",
    scale: 1,
    duration: 500,
    distance: "20px",
    delay: 200,
    viewFactor: 0.1,
  });

  sr.reveal(".revealthis-sequenced", {
    origin: "bottom",
    scale: 1,
    duration: 500,
    distance: "80px",
    delay: 0,
    viewFactor: 0.6,
    interval: 450,
  });

  sr.reveal(".revealthis-sequenced-fast", {
    origin: "bottom",
    scale: 1,
    duration: 500,
    distance: "20px",
    delay: 0,
    viewFactor: 0.8,
    interval: 200,
  });

  sr.reveal(".revealthis-sequenced-right", {
    origin: "right",
    distance: "30%",
    scale: 1,
    delay: 0,
    easing: "cubic-bezier(0.255, 0.745, 0.485, 1)",
    duration: 1300,
    interval: 300,
  });

  sr.reveal(".revealthis-sequenced-left", {
    origin: "left",
    distance: "200px",
    scale: 1,
    delay: 0,
    easing: "cubic-bezier(0.255, 0.745, 0.485, 1)",
    duration: 1300,
    interval: 300,
  });

  sr.reveal(".revealthis-right", {
    origin: "right",
    distance: "30px",
    scale: 0.98,
    delay: 200,
    easing: "cubic-bezier(0.255, 0.745, 0.485, 1)",
    duration: 1300,
  });

  sr.reveal(".revealthis-left", {
    origin: "left",
    distance: "30px",
    scale: 0.98,
    delay: 200,
    easing: "cubic-bezier(0.255, 0.745, 0.485, 1)",
    duration: 1300,
  });

  sr.reveal(".revealthis-top", {
    origin: "top",
    distance: "30px",
    scale: 1,
    delay: 0,
    easing: "cubic-bezier(0.255, 0.745, 0.485, 1)",
    duration: 500,
  });

  sr.reveal(".revealthis-bottom", {
    origin: "bottom",
    distance: "30px",
    scale: 1,
    delay: 0,
    easing: "cubic-bezier(0.255, 0.745, 0.485, 1)",
    duration: 500,
  });

  sr.reveal(
    ".revealthis-bubbles",
    {
      origin: "top",
      scale: 0.1,
      duration: 800,
      distance: "-50px",
    },
    50,
  );

  sr.reveal(".revealthis-bubble", {
    origin: "top",
    scale: 0.1,
    duration: 300,
    distance: "0px",
  });

  sr.reveal(".revealthis-overshoot", {
    origin: "top",
    distance: "30px",
    scale: 1,
    delay: 500,
    easing: "cubic-bezier(.92,.08,.28,1.46)",
    duration: 1000,
  });

  sr.reveal(".revealthis-overshoots", {
    origin: "top",
    distance: "30px",
    scale: 1,
    delay: 200,
    easing: "cubic-bezier(.92,.08,.28,1.46)",
    duration: 700,
    interval: 120,
  });
}
